import { render, staticRenderFns } from "./EmergencyResponseDetailLeft.vue?vue&type=template&id=23b2bb50&scoped=true"
import script from "./EmergencyResponseDetailLeft.vue?vue&type=script&lang=js"
export * from "./EmergencyResponseDetailLeft.vue?vue&type=script&lang=js"
import style0 from "./EmergencyResponseDetailLeft.vue?vue&type=style&index=0&id=23b2bb50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b2bb50",
  null
  
)

export default component.exports